<template>
  <div class="main__content content">
    <div class="pacs-settings-table">
      <div class="pacs-settings-table__group-setting">
        <SmartInputText
          v-model="searchText"
          caption="Поиск"
          class="pacs-settings-table__settings-control pacs-settings-table__settings-control_big"
          size="l"
          @keyup.native.enter="applyTableSettings()"
        >
          <CamsButton
            position="r"
            size="l"
            type="button"
            icon-type="only"
            @click="applyTableSettings()"
          >
            <svg class="icon-search">
              <use xlink:href="#icon-search" />
            </svg>
          </CamsButton>
        </SmartInputText>
      </div>
    </div>

    <SpinnerLoading v-if="isLoadingTable" class="loader_center" color="blue" />
    <PacsTable
      v-else
      :column-captions="columnCaptions"
      :column-names="columnNames"
      :data-rows="dataRows"
      :page-count="pageCount"
      :key-field="keyField"
      :sort-info="sortInfo"
      :total-count="totalCount"
      @new-page="selectPage"
      @new-sort="changeSort"
      :current-page="currentPage"
      :view-only-mode="true"
    />
  </div>
</template>

<script>
import PacsTable from "@/components/pacs/PacsTable.vue";
import {
  ROUTE_PACS_EDIT_HELMET_ANALYTICS,
} from "@/router/names.js";
import {
  ACTION_LOAD_HELMET_ANALYTICS_FOR_TABLE,
  CAMERA_ANALYTICS_STRUCT
} from "@/store/analytics/index.js";
import {entityTableMixin} from "@/components/pacs/mixins.js";

/**
 * Компонент отображения таблицы камер с аналитикой по каскам.
 */
export default {
  name: "TableHelmetAnalytics",
  mixins: [
    entityTableMixin,
  ],
  components: {
    PacsTable
  },
  data() {
    return {
      entityStruct: CAMERA_ANALYTICS_STRUCT,
      entityFields: [
        CAMERA_ANALYTICS_STRUCT.fields.camera_number,
        CAMERA_ANALYTICS_STRUCT.fields.min_confidence,
      ],

    };
  },
  methods: {
    /**
     * @see eventTableMixin.methods.loadPage.
     */
    async loadPage() {
      this.isLoadingTable = true;
      try {
        const responseData = await this.$store.dispatch(`analytics/${ACTION_LOAD_HELMET_ANALYTICS_FOR_TABLE}`, {
          search: this.searchText,
          page: this.currentPage,
        });
        this.pageCount = responseData.page.all;
        this.totalCount = responseData.count;
        this.dataRows = responseData.results.map((rawHelmetInfo) => {
          const cameraNumber = rawHelmetInfo[CAMERA_ANALYTICS_STRUCT.fields.camera_number.name],
                paramsRouteEditHelmetAnalytics = {name: ROUTE_PACS_EDIT_HELMET_ANALYTICS, params: {cameraNumber}};
          return {
            ...this.calcDefaultDataRow(rawHelmetInfo),
            [CAMERA_ANALYTICS_STRUCT.fields.camera_number.name]: {
              type: CAMERA_ANALYTICS_STRUCT.fields.camera_number.type,
              value: cameraNumber,
              params: paramsRouteEditHelmetAnalytics
            },
            [CAMERA_ANALYTICS_STRUCT.fields.min_confidence.name]: {
              value: rawHelmetInfo[CAMERA_ANALYTICS_STRUCT.fields.min_confidence.name],
            },
          };
        });
      } finally {
        this.isLoadingTable = false;
      }
    },
  },
};
</script>
